import { Spin } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { ArrowLeft } from '../../assets/icons';
import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import AccountSidebar from '../../components/AccountSidebar/AccountSidebar';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import SidebarMobile from '../../components/SidebarMobile/SidebarMobile';
import WarningBar from '../../components/WarningBar/WarningBar';
import SecondaryMarketIdentityUpload from '../../components/SecondaryMarketIdentityUpload/SecondaryMarketIdentityUpload';
import { KYC_NOT_VERIFIED_MESSAGE, checkOnboardingComplete } from '../../utils/constant';
import './Account.scss';

const Account = () => {
  const [loading, setLoading] = useState(false);
  const [sideBarName, setSideBarName] = useState('Profile');
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const [showIdentityModal, setShowIdentityModal] = useState(false);
  const userData = useSelector((state) => state.userData);
  let navigate = useNavigate();
  return (
    <div className='account'>
      <div className='sticky-nav' id="account-nav-wrap">
        <AccountNav />
      </div>
      <AccountNavMobile setSideBarName={setSideBarName} />
      <Spin spinning={loading} wrapperClassName={loading && 'ant-spin--fullscreen'} className={loading && 'ant-spin--fullscreen'}>
        <SidebarMobile setPopPage={setSideBarName} popPage={sideBarName} />
        {userData?.isProfileLoaded && (!userData?.userData?.isKYCVerified || (!userData?.userData?.isAMLApproved && userData?.userData?.isDocRequiredForAml)) && (
          <WarningBar
            action={
              !userData?.userData?.isAMLApproved && userData?.userData?.isDocRequiredForAml
                ? () => setShowIdentityModal(true)
                : checkOnboardingComplete(userData?.userData, userData?.counter)
                  ? undefined
                  : () => navigate(`/sign-up/verification`)
            }
            message={
              !userData?.userData?.isAMLApproved && userData?.userData?.isDocRequiredForAml
                ? 'Upload required documents to complete your verification and continue investing with Realbricks!'
                : checkOnboardingComplete(userData?.userData, userData?.counter)
                  ? KYC_NOT_VERIFIED_MESSAGE
                  : undefined
            }
          />
        )}
        <SecondaryMarketIdentityUpload
          visible={showIdentityModal}
          onClose={() => setShowIdentityModal(false)}
          onSuccess={() => setShowIdentityModal(false)}
        />
        <div className='account__body'>
          {isSidebarVisible ? (
            <AccountSidebar />
          ) : (
            <div className='return-link'>
              <Link to='/account/legal' replace onClick={() => setSidebarVisible(true)} className='text-copper fw-600 cursor-pointer mb-32'>
                <ArrowLeft verticalAlign='-6px' /> Return to Account
              </Link>
            </div>
          )}
          <Outlet context={{ setLoading, setSidebarVisible }} />
        </div>
        <MarketFooter />
      </Spin>
    </div>
  );
};

export default Account;
